import React, { useEffect, useState, useRef, useContext } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import MixLogo from "../../assets/images/logo.svg";
import User from "../../assets/images/comman/user.png";
import ProfleBanner from "../../assets/images/comman/profile-banner.png";
import CopyText from "../../components/common/CopyClipboard";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import SidebarMenu from "../../components/Abha-home/ABHA-SidebarMenu";
import { jsPDF } from "jspdf";
import { v4 as uuidv4 } from "uuid";
import {
  // createSession,
  userLogout,
  encryptString,
} from "../../services/apiUtils";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../components/common/Loader";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";
import OTPAuthentication from "../../components/Abha-home/OTP-authentication";

const UserABHAcard = () => {
  const [abhaProfile, setAbhaProfile] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const hasFetched = useRef(false);
  const [showModal, setShowModal] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [verifyWith, setVerifyWith] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [xToken, setXToken] = useState("");
  const [txnId, settxnId] = useState("");
  const [abhaCardImage, setAbhaCardImage] = useState("");

  const navigate = useNavigate();
  const { setDataByKey, getDataByKey } = useContext(GlobalContext);

  const handleLogout = () => {
    userLogout(navigate);
  };

  // Validation functions
  const isValidMobile = (mobile) => {
    return /^[0-9]{10}$/.test(mobile);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Function to fetch updated profile data
  const fetchProfile = async () => {
    try {
      setIsPageLoading(true);
      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;
      // const xToken = localStorage.getItem("x_token");

      // if (!xToken) {
      //   toast.error("Access token or X-token is missing.");
      //   setIsPageLoading(false);
      //   return;
      // }

      const headers = {
        // accesstoken: accessToken,
        // xtoken: `${xToken}`,
        "REQUEST-ID": uuidv4(),
        TIMESTAMP: new Date().toISOString(),
      };

      // Check login method to determine which API to use
      const loginMethod = localStorage.getItem("loginMethod");
      const profileUrl =
        loginMethod === "abhaAddress"
          ? `${API_BASE_URL}/abha/profile/address`
          : `${API_BASE_URL}/abha/profile`;

      const response = await axios.get(profileUrl, { headers });

      if (response.data && response.data.success) {
        const profileData = response.data.data;
        setAbhaProfile(profileData);
        localStorage.setItem(
          "orignalBeneficiaryData",
          JSON.stringify(profileData),
        );
        setIsPageLoading(false);
      } else {
        toast.error("Failed to fetch profile data.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      console.error("Profile fetch error:", error);
      const status = error.response?.status;
      const msg = error.response?.data?.message || error.response?.data?.error || "";
      const isAuthError =
        status === 400 ||
        status === 401 ||
        msg.toLowerCase().includes("x-token") ||
        msg.toLowerCase().includes("accesstoken") ||
        msg.toLowerCase().includes("expired");
      if (isAuthError) {
        toast.error("Session expired. Please login again.");
        setTimeout(() => {
          navigate("/login-ABHA");
        }, 1500);
      } else {
        toast.error("Failed to fetch profile. Please try again.");
      }
    }
  };

  // Function to fetch ABHA card image for display
  const fetchAbhaCardImage = async () => {
    try {
      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;
      // const xToken = localStorage.getItem("x_token");

      // if (!xToken) {
      //   console.log("Authentication tokens not available for image fetch");
      //   return;
      // }

      const headers = {
        "REQUEST-ID": crypto.randomUUID(),
        TIMESTAMP: new Date().toISOString(),
        // xtoken: `${xToken}`,
        // accesstoken: accessToken,
        Accept: "*/*",
      };
      const loginMethod = localStorage.getItem("loginMethod");
      const cardUrl =
        loginMethod === "abhaAddress"
          ? `${API_BASE_URL}/abha/profile/cardbyaddress`
          : `${API_BASE_URL}/abha/profile/abha-card`;
      const response = await axios.get(cardUrl, {
        headers,
        responseType: "blob",
      });

      if (response.data && response.data.size > 0) {
        // Convert blob to base64, then crop to top half
        const reader = new FileReader();
        reader.onload = function () {
          const dataUrl = reader.result;
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const halfHeight = Math.floor(img.height / 2);
            const cropWidth = Math.floor(img.width * 0.5);
            const cropX = Math.floor((img.width - cropWidth) / 2);
            canvas.width = cropWidth;
            canvas.height = halfHeight;

            const ctx = canvas.getContext("2d");
            if (!ctx) {
              console.error("Canvas context not available for ABHA card crop");
              return;
            }

            ctx.drawImage(
              img,
              cropX,
              0,
              cropWidth,
              halfHeight,
              0,
              0,
              cropWidth,
              halfHeight,
            );
            const croppedDataUrl = canvas.toDataURL("image/png");
            const base64Data = croppedDataUrl.split(",")[1];
            setAbhaCardImage(base64Data);
          };
          img.onerror = () => {
            console.error("Failed to load ABHA card image for cropping");
          };
          img.src = dataUrl;
        };
        reader.readAsDataURL(response.data);
      }
    } catch (error) {
      console.error("Fetch ABHA Card Image error:", error);
      // Don't show error toast for background image fetch
    }
  };

  const handleVerification = async (event) => {
    let verifyBy = event == "mobile" ? verifyMobile : verifyEmail;
    setVerifyWith(event);
    setErrorMessage("");
    setIsPageLoading(true);
    try {
      if (verifyBy) {
        // Encrypt mobile/email
        const encryptedValue = await encryptString(verifyBy);
        if (!encryptedValue) {
          setIsPageLoading(false);
          toast.error("Failed to encrypt. Please try again.");
          return;
        }

        // Create session
        // const sessionResponse = await createSession();
        // if (!sessionResponse?.accessToken) {
        //   setIsPageLoading(false);
        //   toast.error(
        //     sessionResponse?.error?.message || "Failed to create session.",
        //   );
        //   return;
        // } else {
        //   setDataByKey("accessToken", sessionResponse.accessToken);
        // }
        let param = {};
        let url = "";
        const header = {
          headers: {
            "Content-Type": "application/json",
            // xtoken: `${xToken}`,
            // accesstoken: `${getDataByKey("accessToken")}`,
          },
        };
        if (event == "mobile") {
          url = `${API_BASE_URL}/abha/update/mobile/send-otp`;
          param = {
            loginId: encryptedValue,
          };
        } else {
          url = `${API_BASE_URL}/abha/update/email/send-otp`;
          param = {
            loginId: encryptedValue,
          };
        }
        const response = await axios.post(url, param, header);
        const dtResponse = response.data;
        if (dtResponse.success) {
          setIsPageLoading(false);
          toast.success(dtResponse.data.message || "OTP Sent");
          settxnId(dtResponse.data.txnId);
          setTimeout(() => {
            setShowModal(true);
          }, 2000);
        }
      } else {
        setIsPageLoading(false);
        toast.error("Please enter a valid mobile number or email");
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response?.data?.success === false &&
        error.response.data.message === "X-token expired"
      ) {
        toast.error(error.response.data.message);
        setTimeout(() => {
          handleLogout();
        }, 3000);
      } else if (
        error.response?.data?.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response?.data?.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };

  useEffect(() => {
    const storedProfile = localStorage.getItem("orignalBeneficiaryData");

    if (storedProfile) {
      const profile = JSON.parse(storedProfile);
      setAbhaProfile(profile);
      setVerifyMobile(profile?.mobile || "");
      setVerifyEmail(profile?.email || "");
    }
    // const x_token = localStorage.getItem("x_token");
    // if (x_token) {
    //   setXToken(x_token);
    // }
    // Fetch fresh profile data on mount/refresh
    fetchProfile();
    // Fetch ABHA card image on mount
    fetchAbhaCardImage();
  }, []);

  // useEffect(() => {
  //     const base64Prefix = "data:image/png;base64,";
  //     const base64String = abhaProfile ? base64Prefix + abhaProfile.profilePhoto : null;
  //     setProfilePhoto(base64String);
  // }, [abhaProfile]);

  // const fetchAbhaQrCode = async () => {
  //     try {
  //         setIsPageLoading(true);
  //         // const sessionResponse = await createSession();
  //        //  const accessToken = sessionResponse?.accessToken;
  //         const xToken = localStorage.getItem('x_token');

  //         if (!accessToken || !xToken) {
  //             toast.error('Access token or X-token is missing.');
  //             setIsPageLoading(false);
  //             return;
  //         }

  //         const headers = {
  //             'accesstoken': accessToken,
  //             'xtoken': xToken,
  //             'REQUEST-ID': uuidv4(),
  //             'TIMESTAMP': new Date().toISOString(),
  //             'Accept': 'image/png',
  //         };

  //         const response = await axios.get(
  //             `${API_BASE_URL}/abha/profile/qrcode`,
  //             {
  //                 headers,
  //                 responseType: 'blob' // Important: Set response type to blob for image data
  //             }
  //         );

  //         if (response.data && response.data.size > 0) {
  //             // Create blob URL from the response
  //             const imageUrl = URL.createObjectURL(response.data);
  //             setQrCodeUrl(imageUrl);
  //             setIsPageLoading(false);
  //         } else {
  //             toast.error('QR code not found in response.');
  //             setIsPageLoading(false);
  //         }

  //     } catch (error) {
  //         setIsPageLoading(false);
  //         console.error('QR Code fetch error:', error);

  //         if (error.response && error.response.data) {
  //             // For blob responses, we need to convert to text first
  //             if (error.response.data instanceof Blob) {
  //                 const text = await error.response.data.text();
  //                 try {
  //                     const errorData = JSON.parse(text);
  //                     if (errorData.success === false && errorData.message === "X-token expired") {
  //                         toast.error(errorData.message);
  //                         setTimeout(() => {
  //                             handleLogout();
  //                         }, 3000);
  //                     } else {
  //                         toast.error(errorData.message || "Server error occurred. Please try again later.");
  //                     }
  //                 } catch (parseError) {
  //                     toast.error("Server error occurred. Please try again later.");
  //                 }
  //             } else {
  //                 // Regular JSON error response
  //                 if (error.response.data.success === false && error.response.data.message === "X-token expired") {
  //                     toast.error(error.response.data.message);
  //                     setTimeout(() => {
  //                         handleLogout();
  //                     }, 3000);
  //                 } else {
  //                     toast.error(error.response.data.message || "Server error occurred. Please try again later.");
  //                 }
  //             }
  //         } else {
  //             toast.error("Network error occurred. Please try again later.");
  //         }
  //     }
  // };

  // useEffect(() => {
  //     if (!hasFetched.current) {
  //         hasFetched.current = true;
  //         fetchAbhaQrCode();
  //     }
  // }, []);

  const downloadABHACard = async () => {
    setIsPageLoading(true);

    try {
      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;
      // const xToken = localStorage.getItem("x_token");

      // if ( !xToken) {
      //   throw new Error("Authentication failed. Please login again.");
      // }

      const headers = {
        "REQUEST-ID": crypto.randomUUID(),
        TIMESTAMP: new Date().toISOString(),
        // xtoken: `${xToken}`,
        // accesstoken: accessToken,
        Accept: "*/*",
      };

      // Check login method to determine which API to use
      const loginMethod = localStorage.getItem("loginMethod");
      const cardUrl =
        loginMethod === "abhaAddress"
          ? `${API_BASE_URL}/abha/profile/cardbyaddress`
          : `${API_BASE_URL}/abha/profile/abha-card`;

      const response = await axios.get(cardUrl, {
        headers,
        responseType: "blob", // Important: Set response type to blob
      });

      if (!response.data || response.data.size === 0) {
        toast.error("No ABHA card data received from the server");
        setIsPageLoading(false);
        return;
      }

      // Determine file type from response headers
      const contentType = response.headers["content-type"] || "application/pdf";
      const blob = new Blob([response.data], { type: contentType });

      if (contentType.includes("application/pdf")) {
        // Handle PDF download directly
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const abhaNumber = abhaProfile?.ABHANumber || "";
        link.download = `ABHA_Card${abhaNumber ? `_${abhaNumber}` : ""}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setIsPageLoading(false);
      } else {
        // Handle image (convert to PDF)
        const reader = new FileReader();
        reader.onloadend = () => {
          const dataUrl = reader.result;
          const img = new Image();

          img.onload = () => {
            const pdf = new jsPDF({ orientation: "portrait", unit: "mm" });
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgRatio = img.height / img.width;
            let imgWidth = pdfWidth;
            let imgHeight = imgWidth * imgRatio;

            if (imgHeight > pdfHeight) {
              imgHeight = pdfHeight;
              imgWidth = imgHeight / imgRatio;
            }

            let imageFormat = "PNG";
            if (contentType.includes("jpeg") || contentType.includes("jpg")) {
              imageFormat = "JPEG";
            } else if (contentType.includes("webp")) {
              imageFormat = "WEBP";
            }

            pdf.addImage(
              dataUrl,
              imageFormat,
              (pdfWidth - imgWidth) / 2,
              (pdfHeight - imgHeight) / 2,
              imgWidth,
              imgHeight,
            );

            const abhaNumber = abhaProfile?.ABHANumber || "";
            const filename = `ABHA_Card${abhaNumber ? `_${abhaNumber}` : ""}.pdf`;
            pdf.save(filename);

            setIsPageLoading(false);
          };

          img.onerror = () => {
            toast.error("Failed to load ABHA card image.");
            setIsPageLoading(false);
          };

          img.src = dataUrl;
        };

        reader.onerror = () => {
          toast.error("Failed to read ABHA card image.");
          setIsPageLoading(false);
        };

        reader.readAsDataURL(blob);
      }
    } catch (error) {
      setIsPageLoading(false);
      console.error("Download ABHA Card error:", error);

      if (error.response && error.response.data) {
        // For blob responses, we need to convert to text first
        if (error.response.data instanceof Blob) {
          const text = await error.response.data.text();
          try {
            const errorData = JSON.parse(text);
            if (
              errorData.success === false &&
              errorData.message === "X-token expired"
            ) {
              toast.error(errorData.message);
              setTimeout(() => {
                handleLogout();
              }, 3000);
            } else {
              toast.error(
                errorData.message ||
                  "Server error occurred. Please try again later.",
              );
            }
          } catch (parseError) {
            toast.error("Server error occurred. Please try again later.");
          }
        } else {
          // Regular JSON error response
          if (
            error.response.data.success === false &&
            error.response.data.message === "X-token expired"
          ) {
            toast.error(error.response.data.message);
            setTimeout(() => {
              handleLogout();
            }, 3000);
          } else {
            toast.error(
              error.response.data.message ||
                "Server error occurred. Please try again later.",
            );
          }
        }
      } else {
        toast.error("Network error occurred. Please try again later.");
      }
    }
  };

  // Function to print ABHA card
  const printABHACard = async () => {
    try {
      setIsPageLoading(true);

      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;
      // const x_token = localStorage.getItem("x_token");

      // if (!accessToken) {
      //   throw new Error("Authentication token not found. Please login again.");
      // }

      const requestId = crypto.randomUUID();
      const timestamp = new Date().toISOString();

      // Check login method to determine which API to use
      const loginMethod = localStorage.getItem("loginMethod");
      const cardUrl =
        loginMethod === "abhaAddress"
          ? `${API_BASE_URL}/abha/profile/cardbyaddress`
          : `${API_BASE_URL}/abha/profile/abha-card`;

      const response = await axios({
        method: "GET",
        url: cardUrl,
        headers: {
          "REQUEST-ID": requestId,
          // xtoken: `Bearer ${x_token}`,
          TIMESTAMP: timestamp,
          // accesstoken: accessToken,
          Accept: "*/*",
        },
        responseType: "blob", // Important: Set response type to blob
      });

      if (!response.data || response.data.size === 0) {
        toast.error("No ABHA card data received from the server");
        setIsPageLoading(false);
        return;
      }

      const contentType = response.headers["content-type"] || "image/png";
      const blob = new Blob([response.data], { type: contentType });

      if (contentType.includes("application/pdf")) {
        const pdfUrl = URL.createObjectURL(blob);
        const printWindow = window.open(pdfUrl);

        if (printWindow) {
          printWindow.addEventListener(
            "load",
            () => {
              printWindow.print();
              setTimeout(() => {
                printWindow.close();
                window.URL.revokeObjectURL(pdfUrl);
              }, 50000);
            },
            { once: true },
          );
        } else {
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.src = pdfUrl;
          document.body.appendChild(iframe);
          iframe.onload = () => {
            iframe.contentWindow.print();
            setTimeout(() => {
              document.body.removeChild(iframe);
              window.URL.revokeObjectURL(pdfUrl);
            }, 50000);
          };
        }

        setIsPageLoading(false);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result;
        const img = new Image();

        img.onload = () => {
          const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
          });

          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          const imgRatio = img.height / img.width;
          let imgWidth = pdfWidth - 20;
          let imgHeight = imgWidth * imgRatio;

          if (imgHeight > pdfHeight - 20) {
            imgHeight = pdfHeight - 20;
            imgWidth = imgHeight / imgRatio;
          }

          let imageFormat = "PNG";
          if (contentType.includes("jpeg") || contentType.includes("jpg")) {
            imageFormat = "JPEG";
          } else if (contentType.includes("webp")) {
            imageFormat = "WEBP";
          }

          pdf.addImage(
            dataUrl,
            imageFormat,
            (pdfWidth - imgWidth) / 2,
            (pdfHeight - imgHeight) / 2,
            imgWidth,
            imgHeight,
          );

          const pdfBlob = pdf.output("blob");
          const pdfUrl = URL.createObjectURL(pdfBlob);

          const printWindow = window.open(pdfUrl);

          if (printWindow) {
            printWindow.addEventListener(
              "load",
              () => {
                printWindow.print();
                setTimeout(() => {
                  printWindow.close();
                  window.URL.revokeObjectURL(pdfUrl);
                }, 50000);
              },
              { once: true },
            );
          } else {
            // Fallback using hidden iframe if popup blocked
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = pdfUrl;
            document.body.appendChild(iframe);
            iframe.onload = () => {
              iframe.contentWindow.print();
              setTimeout(() => {
                document.body.removeChild(iframe);
                window.URL.revokeObjectURL(pdfUrl);
              }, 50000);
            };
          }

          setIsPageLoading(false);
        };

        img.onerror = (error) => {
          toast.error("Failed to process the ABHA card image");
          setIsPageLoading(false);
        };

        img.src = dataUrl;
      };

      reader.onerror = () => {
        toast.error("Failed to read ABHA card image");
        setIsPageLoading(false);
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      setIsPageLoading(false);
      console.error("Print ABHA Card error:", error);

      if (error.response && error.response.data) {
        if (error.response.data instanceof Blob) {
          const text = await error.response.data.text();
          try {
            const errorData = JSON.parse(text);
            if (
              errorData.success === false &&
              errorData.message === "X-token expired"
            ) {
              toast.error(errorData.message);
              setTimeout(() => {
                handleLogout();
              }, 3000);
            } else {
              toast.error(
                errorData.message ||
                  "Server error occurred. Please try again later.",
              );
            }
          } catch (parseError) {
            toast.error("Server error occurred. Please try again later.");
          }
        } else {
          if (
            error.response.data.success === false &&
            error.response.data.message === "X-token expired"
          ) {
            toast.error(error.response.data.message);
            setTimeout(() => {
              handleLogout();
            }, 3000);
          } else {
            toast.error(
              error.response.data.message ||
                "Server error occurred. Please try again later.",
            );
          }
        }
      } else if (error.request) {
        toast.error("No response from server. Please check your connection.");
      } else {
        toast.error("Something went wrong: " + error.message);
      }
    }
  };

  // Function to download and print PVC card
  const downloadAndPrintPVCCard = async () => {
    setIsPageLoading(true);

    try {
      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;
      // const xToken = localStorage.getItem("x_token");

      // if (!accessToken || !xToken) {
      //   throw new Error("Authentication failed. Please login again.");
      // }

      const headers = {
        "REQUEST-ID": crypto.randomUUID(),
        TIMESTAMP: new Date().toISOString(),
        // xtoken: `${xToken}`,
        // accesstoken: accessToken,
        Accept: "image/png",
      };

      // Check login method to determine which API to use
      const loginMethod = localStorage.getItem("loginMethod");
      const cardUrl =
        loginMethod === "abhaAddress"
          ? `${API_BASE_URL}/abha/profile/cardbyaddress`
          : `${API_BASE_URL}/abha/profile/abha-card`;

      const response = await axios.get(cardUrl, {
        headers,
        responseType: "blob", // Important: Set response type to blob
      });

      if (!response.data || response.data.size === 0) {
        toast.error("No ABHA card data received from the server");
        setIsPageLoading(false);
        return;
      }

      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "image/png",
      });
      const imageUrl = URL.createObjectURL(blob);
      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const cardWidth = 1012;
        const cardHeight = 638;

        canvas.width = cardWidth;
        canvas.height = cardHeight;

        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, cardWidth, cardHeight);

        const imgRatio = img.height / img.width;
        let imgWidth = cardWidth - 40;
        let imgHeight = imgWidth * imgRatio;

        if (imgHeight > cardHeight - 40) {
          imgHeight = cardHeight - 40;
          imgWidth = imgHeight / imgRatio;
        }

        ctx.drawImage(
          img,
          (cardWidth - imgWidth) / 2,
          (cardHeight - imgHeight) / 2,
          imgWidth,
          imgHeight,
        );

        const printWindow = window.open("", "_blank");
        if (!printWindow) {
          toast.error(
            "Pop-up blocked! Please allow pop-ups to print the PVC card.",
          );
          setIsPageLoading(false);
          return;
        }

        printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>ABHA PVC Card</title>
                    <style>
                        body {
                            margin: 0;
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100vh;
                        }
                        img {
                            width: 85.6mm;
                            height: 54mm;
                        }
                        @media print {
                            @page {
                                size: 89mm 59mm;
                                margin: 0;
                            }
                        }
                    </style>
                </head>
                <body>
                    <img src="${canvas.toDataURL("image/png")}" alt="ABHA PVC Card" />
                    <script>
                        window.onload = function() {
                            setTimeout(() => {
                                window.print();
                                setTimeout(() => window.close(), 1000);
                            }, 500);
                        }
                    </script>
                </body>
                </html>
            `);

        printWindow.document.close();
        URL.revokeObjectURL(imageUrl);
        setIsPageLoading(false);
      };

      img.onerror = () => {
        toast.error("Failed to load ABHA card image.");
        URL.revokeObjectURL(imageUrl);
        setIsPageLoading(false);
      };

      img.src = imageUrl;
    } catch (error) {
      setIsPageLoading(false);
      console.error("PVC Card error:", error);

      if (error.response && error.response.data) {
        if (error.response.data instanceof Blob) {
          const text = await error.response.data.text();
          try {
            const errorData = JSON.parse(text);
            if (
              errorData.success === false &&
              errorData.message === "X-token expired"
            ) {
              toast.error(errorData.message);
              setTimeout(() => {
                handleLogout();
              }, 3000);
            } else {
              toast.error(
                errorData.message ||
                  "Server error occurred. Please try again later.",
              );
            }
          } catch (parseError) {
            toast.error("Server error occurred. Please try again later.");
          }
        } else {
          if (
            error.response.data.success === false &&
            error.response.data.message === "X-token expired"
          ) {
            toast.error(error.response.data.message);
            setTimeout(() => {
              handleLogout();
            }, 3000);
          } else {
            toast.error(
              error.response.data.message ||
                "Server error occurred. Please try again later.",
            );
          }
        }
      } else if (error.request) {
        toast.error("No response from server. Please check your connection.");
      } else {
        toast.error("Something went wrong: " + error.message);
      }
    }
  };

  // Cleanup QR code URL when component unmounts
  // useEffect(() => {
  //     return () => {
  //         if (qrCodeUrl) {
  //             URL.revokeObjectURL(qrCodeUrl);
  //         }
  //     };
  // }, [qrCodeUrl]);

  // Download QR Code
  // const downloadQRCode = () => {
  //     if (!qrCodeUrl) {
  //         toast.error("QR Code not available");
  //         return;
  //     }

  //     const link = document.createElement('a');
  //     link.href = qrCodeUrl;
  //     link.download = `ABHA_QRCode_${abhaProfile?.ABHANumber || 'card'}.png`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     toast.success("QR Code downloaded successfully");
  // };

  return (
    <>
      {isPageLoading && <Loader />}
      <ToastContainer />
      {showModal && (
        <OTPAuthentication
          onClose={() => setShowModal(false)}
          setShowModal={setShowModal}
          onVerificationSuccess={fetchProfile}
          txnId={txnId}
          verifyWith={verifyWith}
        />
      )}
      <div className="mainFlow">
        <Navbar />
        <div className="container">
          <div className="pranHealtnMainUserFlow">
            <div className="abha-paranLogo">
              <img src={MixLogo} alt="Logo" />
            </div>
            <div className="userFlowAdharVer">
              <div className="user-profile-dashboard">
                <SidebarMenu activePage="abha" />
                <div className="centerBoard">
                  {abhaCardImage && (
                    <img
                      src={`data:image/png;base64,${abhaCardImage}`}
                      alt="ABHA Card"
                      style={{
                        width: "100%",
                        height: "auto",
                        marginBottom: "20px",
                        display: "block",
                      }}
                    />
                  )}
                  <div className="rightProfileMain">
                    {/* <div className="profileBanner">
                                            <img src={ProfleBanner} alt="Profile Banner" />
                                        </div>
                                        <div className="profileUser">
                                            <div className="profileImg">
                                                <img src={profilePhoto || User} alt="Profile" />
                                            </div>
                                            <div className="profileContent">
                                                <h4>{abhaProfile ? abhaProfile.name : ''}</h4>
                                                <p>{abhaProfile ? abhaProfile.mobile : ''} <CopyText text={abhaProfile?.mobile} /></p>
                                            </div>
                                        </div>
                                        <div className="abhaNumber">
                                            <h4>ABHA Number</h4>
                                            <p>{abhaProfile ? abhaProfile.ABHANumber : ''} <CopyText text={abhaProfile?.ABHANumber} /></p>
                                        </div>
                                        <div className="abhaNumber abhaAddress">
                                            <h4>ABHA Address</h4>
                                            <p>{abhaProfile ? abhaProfile.preferredAbhaAddress : ''} <CopyText text={abhaProfile?.preferredAbhaAddress} /></p>
                                        </div>
                                        <div className="abhaNumber dateOfBirthday">
                                            <div>
                                                <h4>Gender</h4>
                                                <p>{abhaProfile ? (abhaProfile.gender === 'M') ? 'Male' : (abhaProfile.gender === 'F') ? 'Female' : '' : ''}</p>
                                            </div>
                                            <div>
                                                <h4>Date Of Birth</h4>
                                                <p>{abhaProfile ? abhaProfile.dayOfBirth + '-' + abhaProfile.monthOfBirth + '-' + abhaProfile.yearOfBirth : ''}</p>
                                            </div>
                                        </div> */}
                    <div className="abhaNumber">
                      <h4>Address</h4>
                      <p>{abhaProfile ? abhaProfile.address : ""}</p>
                    </div>
                    <div className="abhaNumber dateOfBirthday">
                      <div>
                        <h4>State</h4>
                        <p>{abhaProfile ? abhaProfile.stateName : ""}</p>
                      </div>
                      <div>
                        <h4>Pincode</h4>
                        <p>{abhaProfile ? abhaProfile.pincode : ""}</p>
                      </div>
                    </div>
                    <div className="phrAddress">
                      <div className="feilds mb-2">
                        <label>Mobile Number</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            value={verifyMobile}
                            onChange={(e) => {
                              const value = e.target.value.replace(
                                /[^0-9]/g,
                                "",
                              );
                              setVerifyMobile(value);
                            }}
                            className={`form-control ${
                              verifyMobile && isValidMobile(verifyMobile)
                                ? "is-valid"
                                : verifyMobile && !isValidMobile(verifyMobile)
                                  ? "is-invalid"
                                  : ""
                            }`}
                            placeholder="Enter Mobile Number"
                            maxLength={10}
                            style={{ paddingRight: "40px" }}
                          />
                          {isValidMobile(verifyMobile) && (
                            <i
                              className="material-icons"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#4CAF50",
                                fontSize: "20px",
                              }}
                            >
                              check
                            </i>
                          )}
                        </div>
                        {verifyMobile && !isValidMobile(verifyMobile) && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            Please enter a valid 10-digit mobile number
                          </p>
                        )}
                        {isValidMobile(verifyMobile) &&
                          (!abhaProfile?.mobileVerified ||
                            verifyMobile !== abhaProfile?.mobile) && (
                            <span
                              className="verify"
                              onClick={() => handleVerification("mobile")}
                            >
                              Verify
                            </span>
                          )}
                        {errorMessage && verifyWith == "mobile" && (
                          <p style={{ color: "red" }}>{errorMessage}</p>
                        )}
                      </div>
                      <div className="feilds">
                        <label>Email Address</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            onChange={(e) => setVerifyEmail(e.target.value)}
                            value={verifyEmail}
                            placeholder="Enter Email Address"
                            className={`form-control ${
                              verifyEmail && isValidEmail(verifyEmail)
                                ? "is-valid"
                                : verifyEmail && !isValidEmail(verifyEmail)
                                  ? "is-invalid"
                                  : ""
                            }`}
                            style={{ paddingRight: "40px" }}
                          />
                          {isValidEmail(verifyEmail) && (
                            <i
                              className="material-icons"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#4CAF50",
                                fontSize: "20px",
                              }}
                            >
                              check
                            </i>
                          )}
                        </div>
                        {verifyEmail && !isValidEmail(verifyEmail) && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            Please enter a valid email address
                          </p>
                        )}
                        {isValidEmail(verifyEmail) &&
                          (!abhaProfile?.emailVerified ||
                            verifyEmail !== abhaProfile?.email) && (
                            <span
                              className="verify"
                              onClick={() => handleVerification("email")}
                            >
                              Verify
                            </span>
                          )}
                        {errorMessage && verifyWith == "email" && (
                          <p style={{ color: "red" }}>{errorMessage}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="rightDashBord">
                                    <div className="scanner">
                                        <div className="scannerImg" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            {qrCodeUrl ? (
                                                <img src={qrCodeUrl} style={{marginLeft: '35%'}} alt="ABHA QR Code" />
                                            ) : (
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            )}
                                        </div>
                                        <div style={{marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                            <button
                                                className="custBtn btnSuccess"
                                                onClick={downloadQRCode}
                                                disabled={!qrCodeUrl}
                                                style={{
                                                    padding: '10px 20px',
                                                    fontSize: '14px',
                                                    opacity: !qrCodeUrl ? 0.5 : 1,
                                                    cursor: !qrCodeUrl ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                <i className="material-icons" style={{fontSize: '18px', marginRight: '5px'}}>download</i>
                                                Download QR Code
                                            </button>
                                        </div>
                                    </div>
                                </div>*/}
              </div>

              <div className="bottomDashboard">
                <div className="saveBtnProfile justify-content-center">
                  <button
                    className="custBtn btnThems"
                    onClick={downloadABHACard}
                    disabled={loading}
                  >
                    <i className="material-icons">download</i>
                    {loading ? "Downloading..." : "Download ABHA Card"}
                  </button>
                  <button
                    className="custBtn btnThems"
                    onClick={printABHACard}
                    disabled={loading}
                  >
                    <i className="material-icons">print</i>
                    {loading ? "Processing..." : "Print ABHA Card"}
                  </button>
                  <button
                    className="custBtn btnThems"
                    onClick={downloadAndPrintPVCCard}
                    disabled={loading}
                  >
                    <i className="material-icons">credit_card</i>
                    {loading ? "Processing..." : "Print PVC"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserABHAcard;
